/**
 * The currency catalog — `GET /admin/currencies`, backed by the `currencies`
 * table whose id IS the ISO code and which every currency column FKs to.
 *
 * This is the authority on how an amount is written: `symbol` and `decimals`
 * live in the DB, so adding a currency is an INSERT, not a code change and a
 * deploy. The UI previously hand-coded ₹ and $ and guessed at everything else.
 */
import { z } from 'zod';

import type { ApiResult } from './client';
import { get } from './client';

export const currencySchema = z.object({
  /** ISO 4217 code — this is the primary key. */
  id: z.string(),
  display_name: z.string(),
  /** May be null: not every currency has a symbol worth showing. */
  symbol: z.string().nullable(),
  /** Minor-unit digits. JPY/KRW are 0 — not a rounding preference. */
  decimals: z.number(),
});
export const currencyListSchema = z.array(currencySchema);
export type Currency = z.infer<typeof currencySchema>;

export const listCurrencies = (signal?: AbortSignal): Promise<ApiResult<Currency[]>> =>
  get('/admin/currencies', currencyListSchema, { signal }) as Promise<ApiResult<Currency[]>>;
